import { render, staticRenderFns } from "./reporteCargas.vue?vue&type=template&id=4765b30d&"
import script from "./reporteCargas.vue?vue&type=script&lang=js&"
export * from "./reporteCargas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports